import React from 'react';
import { useController } from 'react-hook-form';
import TextareaAutosizeElement from './rh-text-area-autosize-element';

export default function JSONTextareaAutosizeElement(props) {
  const { validationMessage = "Must be valid JSON or a simple string", ...rest } = props;

  // Use controller to integrate with react-hook-form
  const {
    field,
    fieldState: { error },
  } = useController({
    name: props.name,
    control: props.control,
    rules: {
      validate: (value) => {
        // Validation logic: valid JSON or simple string
        try {
          if (typeof value === 'string') {
            JSON.parse(value); // Test if it can parse JSON
          }
          return true; // Valid if JSON or a string
        } catch {
          return validationMessage; // Return custom validation message
        }
      },
    },
  });

  return (
    <div>
      <TextareaAutosizeElement
        {...rest}
        {...field}
        error={!!error}
        helperText={error?.message} // Display validation message if there's an error
      />
    </div>
  );
}
